export const products = [
  {
    id: 'p1',
    name: 'Volcano Eruption Starter Kit',
    price: 24.99,
    category: 'Chemistry',
    ageRange: '6-8',
    image: 'https://images.unsplash.com/photo-1618426002018-09553f191753?auto=format&fit=crop&w=600&q=80',
    description: 'Explore basic chemical reactions with this hands-on volcano model. Includes safe ingredients and a durable reusable volcano base.',
    isBundle: false,
  },
  {
    id: 'p2',
    name: 'First Explorer Microscope Set',
    price: 39.99,
    category: 'Biology',
    ageRange: '9-12+',
    image: 'https://images.unsplash.com/photo-1582719471384-894fbb16e074?auto=format&fit=crop&w=600&q=80',
    description: 'A beginner-friendly microscope with prepared slides and blank slides for collecting your own samples. Supports careful observation skills.',
    isBundle: false,
  },
  {
    id: 'p3',
    name: 'Magnetic Building Tiles (50pc)',
    price: 34.99,
    category: 'Engineering',
    ageRange: '3-5',
    image: 'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1?auto=format&fit=crop&w=600&q=80',
    description: 'Chunky, easy-to-hold magnetic tiles that encourage spatial awareness and basic structural design.',
    isBundle: false,
  },
  {
    id: 'p4',
    name: 'Crystal Growing Lab',
    price: 19.99,
    category: 'Chemistry',
    ageRange: '6-8',
    image: 'https://images.unsplash.com/photo-1574620138927-463d1e11a141?auto=format&fit=crop&w=600&q=80',
    description: 'Observe crystal formation over several days. A fascinating introduction to geology and patience in scientific observation.',
    isBundle: false,
  },
  {
    id: 'p5',
    name: 'Solar System Planetarium',
    price: 29.99,
    category: 'Astronomy',
    ageRange: '6-8',
    image: 'https://images.unsplash.com/photo-1614730321146-b6fa6a46bcb4?auto=format&fit=crop&w=600&q=80',
    description: 'Paint and assemble your own model of the solar system. Helps visualize planetary orbits and relative sizes.',
    isBundle: false,
  },
  {
    id: 'p6',
    name: 'Robotics Starter Bug',
    price: 45.99,
    category: 'Technology',
    ageRange: '9-12+',
    image: 'https://images.unsplash.com/photo-1589254065878-42c9da997008?auto=format&fit=crop&w=600&q=80',
    description: 'Build a basic crawling robot while learning about simple circuits and mechanical movement. Requires adult supervision for assembly.',
    isBundle: false,
  },
  {
    id: 'b1',
    name: 'The Ultimate Chemist Bundle',
    price: 39.99, // Discounted from ~45
    category: 'Chemistry',
    ageRange: '6-8',
    image: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=600&q=80',
    description: 'Includes both the Volcano Eruption Kit and the Crystal Growing Lab for a comprehensive introduction to basic chemistry concepts.',
    isBundle: true,
  },
  {
    id: 'b2',
    name: 'Little Explorer Pack',
    price: 64.99,
    category: 'Mixed',
    ageRange: '9-12+',
    image: 'https://images.unsplash.com/photo-1518152006812-edab29b069ac?auto=format&fit=crop&w=600&q=80',
    description: 'Bundle includes the First Explorer Microscope and the Robotics Starter Bug. Great for curious minds ready for more complex projects.',
    isBundle: true,
  }
];

export const reviews = [
  {
    id: 1,
    author: "Sarah M.",
    role: "Parent of 7yo",
    text: "The volcano kit was a huge hit! The instructions were clear, and I appreciated the safety reminders. It sparked a great conversation about geology."
  },
  {
    id: 2,
    author: "David L.",
    role: "Science Teacher",
    text: "I recommend these kits to parents looking for weekend activities. They don't overpromise; they just deliver solid, foundational STEM experiences."
  },
  {
    id: 3,
    author: "Elena R.",
    role: "Parent of 4yo & 9yo",
    text: "Love that I can filter by age. The magnetic tiles keep my youngest busy while my oldest works on the microscope slides. Great quality."
  }
];

export const faqs = [
  {
    question: "Are these kits safe for my child to use alone?",
    answer: "While our kits are designed with safety in mind and use non-toxic materials where possible, adult supervision is recommended for all activities. This ensures safety and also provides a great opportunity for collaborative learning."
  },
  {
    question: "What is your shipping policy?",
    answer: "We offer standard shipping (3-5 business days) for $5.99, and free shipping on orders over $50. Expedited shipping options are available at checkout."
  },
  {
    question: "How do I process a return?",
    answer: "We accept returns of unopened kits within 30 days of purchase. Please contact our support team to initiate a return. Return shipping costs are the responsibility of the customer unless the item arrived damaged."
  },
  {
    question: "Do you offer replacement parts?",
    answer: "Yes, we know pieces can go missing! Contact our support team with your order number and the part you need, and we'll do our best to help."
  }
];